<script>
    import { createEventDispatcher } from "svelte";
    import { intToEuro } from "../../utils/utils";

    export let reward;
    reward = reward ?? {};

    const dispatch = createEventDispatcher();

    function remove () {
        dispatch("remove", reward)
    }
</script>

<div>
    {#if reward.type == "cash_voucher"}
        Wertgutschein: {intToEuro(reward.value)}
    {:else if reward.type == "product_voucher"}
        Sachgutschein: {reward.name}
    {:else if reward.type == "product"}
        Gratisprodukt: {reward.name??"Produkt"}
    {/if}
</div>

<style>
    div {
        background-color: rgb(180, 230, 170);
        color: rgb(0, 60, 3);
        border-radius: 1rem;
        padding: 0.5rem 1rem;
        line-height: 1rem;
        display: inline-block;
        margin-bottom: 0.5rem;
    }
</style>